export default "__VITE_ASSET__Do2izbxb__"